var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        loading: _vm.loading,
        'not-loading': !_vm.loading,
        contained: _vm.contained,
        inline: _vm.inline,
        transparent: _vm.transparent,
    }},[_c('div',{staticClass:"sub-container"},[_c('i',{staticClass:"asknicely-icon-loader_static"}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }